module.exports = __webpack_public_path__ + "./Sharon_pbw_9f70b43394d09cb833af0beed6c89256.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Sharon_pbw.png
// module id = 607
// module chunks = 0